import { observable } from "mobx";
import { Type } from "class-transformer";
import MonthOfYearRangeResponse from "./monthOfYearRangeResponse";
import AccountingDocumentsInventoryStatus from "./accountingDocumentsInventoryStatus";
import AccountingDocumentsInventoryCheckResult from "./accountingDocumentsInventoryCheckResult";
import AccountingDocumentsInventoryPermittedActionsResponse from "./accountingDocumentsInventoryPermittedActionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryResponse {
  @observable
  id!: string;

  @observable
  @Type(() => MonthOfYearRangeResponse)
  accountingPeriodMonthRange!: MonthOfYearRangeResponse;

  @observable
  status!: AccountingDocumentsInventoryStatus;

  @observable
  checkResult?: AccountingDocumentsInventoryCheckResult;

  @observable
  @Type(() => Date)
  updatedAt!: Date;

  @observable
  updatedBy?: string;

  @observable
  @Type(() => AccountingDocumentsInventoryPermittedActionsResponse)
  permittedActions!: AccountingDocumentsInventoryPermittedActionsResponse;
}
